import React from 'react'

const profile = {
  name: 'Krishnendu Addya',
  company: 'PwC India',
  designation: 'Senior Associate',
  location: 'Kolkata, West Bengal, India',
  skills: [
    'C#', '.NET Core', 'SQL', 'HTML', 'CSS', 'JS', 'React', 'Redux', 'Azure'
  ],
  hardWorker: true,
  quickLearner: true,
  problemSolver: true,
  hireable: function () {
    return (
      this.hardWorker &&
      this.problemSolver &&
      this.skills.length >= 5
    );
  }
};

const Coder = () => {
  const [displayed, setDisplayed] = React.useState({});

  // Helper to split a string into an array of letters
  const splitLetters = (str) => str.split('');

  // All fields to animate
  const fields = [
    { key: 'name', value: profile.name },
    { key: 'company', value: profile.company },
    { key: 'designation', value: profile.designation },
    { key: 'location', value: profile.location },
    { key: 'skills', value: profile.skills },
    { key: 'hardWorker', value: String(profile.hardWorker) },
    { key: 'quickLearner', value: String(profile.quickLearner) },
    { key: 'problemSolver', value: String(profile.problemSolver) }
  ];

  React.useEffect(() => {
    let timeouts = [];
    let current = {};
    let skillLetters = profile.skills.map(skill => splitLetters(skill));
    let skillIndexes = Array(profile.skills.length).fill(0);

    // Animate each field one by one
    const animateField = (idx) => {
      if (idx >= fields.length) {
        return;
      }
      const field = fields[idx];
      if (field.key === 'skills') {
        // Animate each skill one by one
        let skillIdx = 0;
        const animateSkill = () => {
          if (skillIdx >= profile.skills.length) {
            setTimeout(() => animateField(idx + 1), 200);
            return;
          }
          let letters = '';
          const animateLetter = () => {
            if (skillIndexes[skillIdx] < skillLetters[skillIdx].length) {
              letters += skillLetters[skillIdx][skillIndexes[skillIdx]];
              skillIndexes[skillIdx]++;
              current.skills = [
                ...(current.skills || []),
              ];
              current.skills[skillIdx] = letters;
              setDisplayed({ ...current });
              timeouts.push(setTimeout(animateLetter, 40));
            } else {
              skillIdx++;
              setTimeout(animateSkill, 100);
            }
          };
          animateLetter();
        };
        animateSkill();
      } else {
        let letters = '';
        let i = 0;
        const animateLetter = () => {
          if (i < field.value.length) {
            letters += field.value[i];
            i++;
            current[field.key] = letters;
            setDisplayed({ ...current });
            timeouts.push(setTimeout(animateLetter, 40));
          } else {
            setTimeout(() => animateField(idx + 1), 150);
          }
        };
        animateLetter();
      }
    };

    animateField(0);

    return () => timeouts.forEach(clearTimeout);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <div className="order-1 lg:order-2 from-[#0d1224] border-[#1b2c68a0] relative rounded-lg border bg-gradient-to-r to-[#0a0d37] font-nunito">
        <div className="flex flex-row">
          <div className="h-[1px] w-full bg-gradient-to-r from-transparent via-pink-500 to-violet-600"></div>
          <div className="h-[1px] w-full bg-gradient-to-r from-violet-600 to-transparent"></div>
        </div>
        <div className="px-4 lg:px-8 py-4">
          <div className="flex flex-row space-x-2">
            <div className="h-3 w-3 rounded-full bg-red-500"></div>
            <div className="h-3 w-3 rounded-full bg-orange-400"></div>
            <div className="h-3 w-3 rounded-full bg-green-400"></div>
          </div>
        </div>
        <div className="overflow-hidden border-t-[2px] border-indigo-900 px-4 lg:px-8 py-4 lg:py-8">
          <code className="font-mono text-[0.85rem] sm:text-sm md:text-sm lg:text-m">
            <div className="blink">
              <span className="mr-2 text-pink-500">const</span>
              <span className="mr-2 text-white">profile</span>
              <span className="mr-2 text-pink-500">=</span>
              <span className="text-gray-400">{'{'}</span>
            </div>
            <div>
              <span className="ml-4 lg:ml-8 mr-2 text-white">name:</span>
              <span className="text-gray-400">{`'`}</span>
              <span className="text-green-400">{displayed.name || ''}</span>
              <span className="text-gray-400">{`',`}</span>
            </div>
            <div>
              <span className="ml-4 lg:ml-8 mr-2 text-white">company:</span>
              <span className="text-gray-400">{`'`}</span>
              <span className="text-green-400">{displayed.company || ''}</span>
              <span className="text-gray-400">{`',`}</span>
            </div>
            <div>
              <span className="ml-4 lg:ml-8 mr-2 text-white">designation:</span>
              <span className="text-gray-400">{`'`}</span>
              <span className="text-green-400">{displayed.designation || ''}</span>
              <span className="text-gray-400">{`',`}</span>
            </div>
            <div>
              <span className="ml-4 lg:ml-8 mr-2 text-white">location:</span>
              <span className="text-gray-400">{`'`}</span>
              <span className="text-green-400">{displayed.location || ''}</span>
              <span className="text-gray-400">{`',`}</span>
            </div>
            <div className="ml-4 lg:ml-8 mr-2">
              <span className=" text-white">skills: </span>
              <span className="text-gray-400">{`[`}</span>
              {(displayed.skills || []).map((skill, idx) => (
                <span key={profile.skills[idx]}>
                  <span className="text-blue-500">{skill}</span>
                  {idx < profile.skills.length - 1 && <span className="text-gray-400">{", "}</span>}
                </span>
              ))}
              <span className="text-gray-400">{`]`}</span>
            </div>
            <div>
              <span className="ml-4 lg:ml-8 mr-2 text-white">hardWorker:</span>
              <span className="text-orange-400">{displayed.hardWorker || ''}</span>
              <span className="text-gray-400">,</span>
            </div>
            <div>
              <span className="ml-4 lg:ml-8 mr-2 text-white">quickLearner:</span>
              <span className="text-orange-400">{displayed.quickLearner || ''}</span>
              <span className="text-gray-400">,</span>
            </div>
            <div>
              <span className="ml-4 lg:ml-8 mr-2 text-white">problemSolver:</span>
              <span className="text-orange-400">{displayed.problemSolver || ''}</span>
              <span className="text-gray-400">,</span>
            </div>
            <div>
              <span className="ml-4 lg:ml-8 mr-2 text-green-400">hireable:</span>
              <span className="text-orange-400">function</span>
              <span className="text-gray-400">{'() {'}</span>
            </div>
            <div>
              <span className="ml-8 lg:ml-16 mr-2 text-orange-400">return</span>
              <span className="text-gray-400">{`(`}</span>
            </div>
            <div>
              <span className="ml-12 lg:ml-24 text-cyan-400">this.</span>
              <span className="mr-2 text-white">hardWorker</span>
              <span className="text-amber-300">&amp;&amp;</span>
            </div>
            <div>
              <span className="ml-12 lg:ml-24 text-cyan-400">this.</span>
              <span className="mr-2 text-white">problemSolver</span>
              <span className="text-amber-300">&amp;&amp;</span>
            </div>
            <div>
              <span className="ml-12 lg:ml-24 text-cyan-400">this.</span>
              <span className="mr-2 text-white">skills.length</span>
              <span className="mr-2 text-amber-300">&gt;=</span>
              <span className="text-orange-400">5</span>
            </div>
            <div><span className="ml-8 lg:ml-16 mr-2 text-gray-400">{`);`}</span></div>
            <div><span className="ml-4 lg:ml-8 text-gray-400">{`};`}</span></div>
            <div><span className="text-gray-400">{`};`}</span></div>
          </code>
          <div className="mt-6 flex flex-wrap gap-2">
            {(displayed.skills || []).map((skill, idx) => (
              <span
                key={profile.skills[idx]}
                className="text-[#61dafb] px-2 py-1 rounded border border-[#61dafb] text-[0.85rem] font-semibold shadow-sm transition-colors duration-200"
                style={{
                  backgroundColor: '#0a0d37',
                  color: ' #61dafb',
                  cursor: 'pointer'
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.backgroundColor = ' #61dafb';
                  e.currentTarget.style.color = '#0a0d37';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.backgroundColor = '#0a0d37';
                  e.currentTarget.style.color = '#61dafb';
                }}
              >
                {skill}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Coder